import React, { useContext, useEffect, useRef, useState } from 'react';
import successIcon from '../documents/success.svg';
import loaderIcon from '../documents/Loader.svg';
import thumbIcon from '../documents/thumb.svg';
import preview from '../documents/GST.png';
import camIcon from '../documents/cam.svg';
import { DOCUMENT_TYPE_ENUM, DOC_ARRAY_AADHAR, DOC_ARRAY_PAN, INVALID_FILE_SIZE_MESSAGE, STANDARD_FILE_SIZE } from '../documents/constant';
import { getFromSessionStorage, handleError } from 'common/utils/app.utils';
import { DEFAULT_TOAST_MSG, ERROR_TOAST, MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN } from 'home/view/manage-feasibility/constants';
import { deleteDocumentsForSummary, fetchOrder, fetchOrderDetails, getUploadedDocumentsForSummary, uploadDocumentsForSummary } from 'home/view/manage-feasibility/services';
import { doc } from 'prettier';
import { getCurrentLead } from 'tokenGeneration/lead.util';
import { debug } from 'util';
import { AppContext } from 'App';

const UploadDocCard = ({
  setIsSaveBtnDisabled,
  setKdmAccordionValidation,
  order,
  documentObj,
  keyName,
  setAllDocUpload,
  uploadedDoc,
  setUploadedDoc,
  togglePopUp,
  getOrderedImages,
  fetchOrderFn,
  kdmImagePresent = false,
  companyGstValidation
}) => {
  const fileCaptureRef = useRef();
  const [uploadError, setUploadError] = useState(null);
  const [uploadLoader, setUploadLoader] = useState(false);
  const [updateImageList, setUpdateImageList] = useState(false);
  const [getImage, setGetImages] = useState(false);
  const [retryImage, setRetryImage] = useState(false);
  const [progressValue, setProgressValue] = useState(0);
  const [previewImage, setPreviewImage] = useState(null);

  const { setToast } = useContext(AppContext);

  const summaryAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN);
  //   setUploadedDoc({PAN_FRONT:"s3://b2b-acquisition/b2b-online-acquisition/OSAOIOTH15032417864/kdm/1710502042152_OSAOIOTH15032417864_0.jpeg"})

  const accordionValidation = (orderDetails) => {
    const authSignDocs = orderDetails?.documents?.AUTHORIZED_SIGNATORY || order?.documents?.AUTHORIZED_SIGNATORY;
    const obj = {};
    authSignDocs &&
      Object.keys(authSignDocs).forEach((item) => {
        if (item !== 'KDM') {
          obj[item] = authSignDocs[item];
        }
      });
    const livePhotoClicked = authSignDocs?.['KDM'];
    // const livePhotoClicked = true;

    const len = Object.keys(obj)?.length;
    const docType = Object.keys(obj)[0]?.split('_')[0];
    if (docType === 'PAN') {
      // setKdmAccordionValidation(len === 1 );
      // setKdmAccordionValidation(!(len !== 1 || !livePhotoClicked) || kdmImagePresent);
      setKdmAccordionValidation(kdmImagePresent && livePhotoClicked && len === Object.keys(DOC_ARRAY_PAN).length);
      // setIsSaveBtnDisabled(len !== 1 || !livePhotoClicked || !kdmImagePresent);
      setIsSaveBtnDisabled(!(kdmImagePresent && livePhotoClicked && len === Object.keys(DOC_ARRAY_PAN).length && companyGstValidation));
    } else if (docType === 'AADHAAR') {
      // setKdmAccordionValidation(len === 2);
      setKdmAccordionValidation(kdmImagePresent && livePhotoClicked && len === Object.keys(DOC_ARRAY_AADHAR).length);
      // setIsSaveBtnDisabled(len !== 2 || !livePhotoClicked || !kdmImagePresent);
      setIsSaveBtnDisabled(!(kdmImagePresent && livePhotoClicked && len === Object.keys(DOC_ARRAY_AADHAR).length && companyGstValidation));
    } else if (!docType) {
      setKdmAccordionValidation(false);
      setIsSaveBtnDisabled(true);
    }

    // console.log(!(len !== 2 || !livePhotoClicked) || kdmImagePresent, "kdm", obj, (kdmImagePresent && livePhotoClicked && len ===2))
  };

  const onSuccessCb = (order) => {
    // setReRender(!reRender)
    uploadedDocsObj(order);
  };

  const uploadedDocsObj = (orderDetail) => {
    // console.log(order)
    const authSignDocs = orderDetail?.documents?.AUTHORIZED_SIGNATORY || order?.documents?.AUTHORIZED_SIGNATORY;
    // console.log(authSignDocs, 'auth');
    // console.log(orderDetail, 'order');
    const obj = {};
    authSignDocs &&
      Object.keys(authSignDocs).forEach((item) => {
        if (item !== 'KDM') {
          obj[item] = authSignDocs[item];
        }
      });
    setUploadedDoc(obj);
    accordionValidation(orderDetail || order);
  };

  const onUploadProgress = (progressEvent) => {
    const loadingPercentage = (progressEvent.loaded / progressEvent.total) * 100;
    setProgressValue(loadingPercentage - 5);
  };

  const handleUploadImages = (event) => {
    const { name, files } = event && event.target;
    setUploadError(null);
    setUploadLoader(true);
    let docList = [];
    if (files && files.length > 0) {
      let i = 0;
      while (i < files.length) {
        let file = files[i];
        if (!validateFile(file)) {
          delete uploadedDoc[name];
          // const obj = {};
          // const docs = Object.keys(authSignDocs).forEach(item=>{
          //   if(item !== 'KDM')
          //   {
          //     obj.push(item)
          //   }})
          // setUploadedDoc(docs);
          setUploadedDoc(uploadedDoc);
          setUpdateImageList(true);
          setUploadError(INVALID_FILE_SIZE_MESSAGE);
          setUploadLoader(false);
        } else {
          docList.push({
            name: name,
            document: file,
            uploaded: true
          });
        }
        i++;
      }
      uploadDocuments(docList);
      if (fileCaptureRef && fileCaptureRef.current) {
        fileCaptureRef.current.value = null;
      }
    } else {
      setUploadLoader(false);
    }
  };

  // const abc = async () => {
  //   await fetchOrderFn()
  // }

  const uploadDocuments = async (docList) => {
    const typeOfDocument = docList[0]?.name;
    const formData = new FormData();
    formData.append(`documents['${typeOfDocument}']`, docList[0].document);
    formData.append('documentType', DOCUMENT_TYPE_ENUM.AUTHORIZED_SIGNATORY);

    try {
      const { res, err } = await uploadDocumentsForSummary(formData, summaryAuthToken, onUploadProgress);
      if (res) {
        setUploadLoader(false);
        fetchOrderFn(null, summaryAuthToken, onSuccessCb);
      } else {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;
        console.log(errorMsg, 'uploaderror');
        setToast(true, errorMsg, ERROR_TOAST);
        setUploadLoader(false);
        window.scrollTo(0, 0);
      }
    } catch (err) {
      console.log(err, 'uploaderror');
    }
    // uploadDocumentsForSummary(formData, summaryAuthToken, onUploadProgress).then(
    //   async (resp) => {
    //     setUploadLoader(false);

    //     fetchOrderFn(null, summaryAuthToken, onSuccessCb);
    //   },
    //   (error) => {
    //     handleError(error);
    //   }
    // );
  };

  const getDocuments = async (keyName) => {
    const payload = { documentType: 'AUTHORIZED_SIGNATORY', documentName: keyName };

    try {
      const { res, err } = await getUploadedDocumentsForSummary(payload, summaryAuthToken);

      if (res) {
        // console.log(res, 'images fetched');
        const { data } = res;
        const type = 'image/jpeg';

        const file = new Blob([data], { type });

        var fileURL = URL.createObjectURL(file);
        window.open(fileURL, '_blank');
      } else if (err) {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        setError({
          state: true,
          message: errorMsg || 'Error while opening files'
        });

        setToast(true, errorMsg, ERROR_TOAST);
        window.scrollTo(0, 0);
        throw new Error(errorMsg);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const deleteUploadedFile = async (documentName) => {
    const payload = { documentType: 'AUTHORIZED_SIGNATORY', documentName };
    try {
      const { res, err } = await deleteDocumentsForSummary(payload, summaryAuthToken);
      if (res) {
        fetchOrderFn(null, summaryAuthToken, onSuccessCb);
      }
    } catch (e) {
      const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;
      setToast(true, errorMsg, ERROR_TOAST);
      window.scrollTo(0, 0);
      // console.error(e);
      console.error(e);
    }
  };

  const downloadImage = () => {};

  const handleChangeImage = (keyName) => {
    // console.log(keyName);
    deleteUploadedFile(keyName);
    // accordionValidation();
  };

  const handleImagePreview = (keyName) => {
    // console.log(keyName, "keyname");
    getDocuments(keyName);

    // return (
    //   <img src={previewImage? previewImage: ''} alt="..." />
    // )
  };

  const validateFile = (file) => {
    let fileSize = Math.ceil(file.size / (1024 * 1024));
    if (fileSize > STANDARD_FILE_SIZE) {
      return false;
    }
    return true;
  };

  useEffect(() => {
    accordionValidation(order);
  });

  useEffect(() => {
    if (uploadedDoc && documentObj && Object.keys(uploadedDoc).length === Object.keys(documentObj).length) {
      setAllDocUpload(true);
    } else if (getOrderedImages && documentObj && Object.keys(documentObj).length === getOrderedImages.length) {
      setAllDocUpload(true);
    } else {
      setAllDocUpload(false);
    }
    // fetchOrderFn();
  }, [updateImageList]);

  return (
    <li>
      <div className={`${uploadLoader ? 'uploading' : uploadedDoc && uploadedDoc[keyName] && !uploadError ? 'upload_success' : uploadError ? 'upload_failed' : 'before_upload'}`}>
        {/* cam add class "upload_failed, uploading, upload_success" according to files tatus  */}
        <div className="item">
          <div className="docs-content">{uploadedDoc && uploadedDoc[keyName] ? <img src={preview} alt="Preview Image" /> : ''}</div>
          <div className="dropbox">
            <div className="box-content">
              {uploadedDoc && uploadedDoc[keyName] && (
                <>
                  <div className="success-content">
                    <img src={successIcon} alt="Success" />
                    <div className="text">Upload Successfully</div>
                    <div className="action-text">
                      <span className="view-link" onClick={() => handleImagePreview(keyName)}>
                        Preview
                      </span>
                      <span className="view-link" onClick={() => handleChangeImage(keyName)}>
                        Delete
                      </span>
                      <input
                        id={keyName}
                        type="file"
                        className="hidden"
                        accept=".png, .jpg, .jpeg, .pdf"
                        capture="camera"
                        name={keyName}
                        onChange={(event) => handleUploadImages(event)}
                        ref={fileCaptureRef}
                      />
                    </div>
                  </div>
                </>
              )}
              {uploadLoader && (
                <div className="uploading-content">
                  <img src={loaderIcon} alt="Loader" />
                  <div className="text">Uploading.....</div>
                </div>
              )}
              {getImage && (
                <div className="uploading-content">
                  <img src={loaderIcon} alt="Loader" />
                  <div className="text">fetching.....</div>
                </div>
              )}
              <div className="failed-content">
                {!retryImage && (
                  <div className="action-text">
                    <label htmlFor={keyName}>
                      <span className="icons hide-mobile">
                        <img src={thumbIcon} alt="Pic" />
                      </span>
                      <span className="icons show-mobile">
                        <img src={camIcon} alt="Cam" />
                      </span>
                    </label>

                    <input
                      id={keyName}
                      type="file"
                      className="hidden"
                      accept=".png, .jpg, .jpeg, .pdf"
                      capture="camera"
                      name={keyName}
                      onChange={(event) => handleUploadImages(event)}
                      ref={fileCaptureRef}
                    />
                  </div>
                )}

                {uploadError ? (
                  <div className="text">{INVALID_FILE_SIZE_MESSAGE}</div>
                ) : retryImage ? (
                  <div className="text">
                    We are unable to fetch image{' '}
                    <span className="link" onClick={() => getDocuments(keyName)}>
                      Retry
                    </span>
                  </div>
                ) : (
                  <div className="text">Upload {documentObj && documentObj[keyName]}</div>
                )}
              </div>
            </div>
          </div>
        </div>
        <p className={'document-name'}> {documentObj && documentObj[keyName]}</p>
      </div>
    </li>
  );
};

UploadDocCard.defaultProps = {
  moEngageKey: {}
};

export default UploadDocCard;
